import { render, staticRenderFns } from "./biaozhunService.vue?vue&type=template&id=52efdbc8&scoped=true"
import script from "./biaozhunService.vue?vue&type=script&lang=js"
export * from "./biaozhunService.vue?vue&type=script&lang=js"
import style0 from "./biaozhunService.vue?vue&type=style&index=0&id=52efdbc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52efdbc8",
  null
  
)

export default component.exports